import { createRoot } from 'react-dom/client';
import { createLDReactProvider } from '@launchdarkly/react-sdk';
import { App } from './App';
import { options } from "./utility/options";

import './index.css';
import './components/charts/common/charts.css';

const key = options.launchDarklyKey;
if (!key) {
  throw new Error('You are missing a LaunchDarkly client side id.')
}

const LDProvider = createLDReactProvider(
  key,
  {
    kind: 'user',
    anonymous: true,
  },
  {
    ldOptions: {
      useCamelCaseFlagKeys: false,
    },
  },
);

createRoot(document.getElementById('root')!).render(
  // TODO: DD - Due to react-barcode-reader third party library, we had to disable strict mode
  // <React.StrictMode>
  <LDProvider>
    <App />
  </LDProvider>
  // </React.StrictMode>
  ,
);
